
import { Navigate } from 'react-router-dom';


const RequireAuth = ({ children }) => {

    let auth = localStorage.getItem('token')

    return auth ? children : Navigate({ to: '/', replace:true })
}


export { RequireAuth };

